import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityMigration } from "../../entity/EntityMigration";

export class DtoMigrationsDeleteReq extends EntityMigration {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (
      !commonRegx.isMatch(
        this.c_migration_id!.toString(),
        "^\\d+$",
        commonRegx._stdOption
      )
    ) {
      res.push("type error");
    }

    return res;
  }
}
